import { isNativeApp, isPwa } from '@trustoo/utils/environment/runtime'

export type TrustooAppType = 'pro' | 'demand' | 'public'
export type TrafficSource = 'web' | 'pwa' | 'app_demand' | 'app_pro'

let currentAppType: TrustooAppType = 'public'

// Set once at boot by each app so shared trackers can resolve `traffic_source`
// without knowing which app they were imported into. The native app wraps
// `pro` and `demand` but not `public`, so `public` can never resolve to `app_*`.
export function setAppType(appType: TrustooAppType): void {
    currentAppType = appType
}

export function getAppType(): TrustooAppType {
    return currentAppType
}

// Resolves the GA4 `traffic_source` custom-dimension value for the current
// runtime context. Native wins over PWA because it is an explicit signal
// injected by the wrapper, while PWA is inferred from `display-mode`.
export function getTrafficSource(): TrafficSource {
    if (currentAppType !== 'public' && isNativeApp()) {
        return currentAppType === 'pro' ? 'app_pro' : 'app_demand'
    }
    if (isPwa()) {
        return 'pwa'
    }
    return 'web'
}
